import { render, staticRenderFns } from "./DialogRemark.vue?vue&type=template&id=1a702c30&scoped=true&"
import script from "./DialogRemark.vue?vue&type=script&lang=js&"
export * from "./DialogRemark.vue?vue&type=script&lang=js&"
import style0 from "./DialogRemark.vue?vue&type=style&index=0&id=1a702c30&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a702c30",
  null
  
)

export default component.exports